import React, { useEffect } from 'react';
import { usePages, useGuideConfig } from '@ignitesales/neuro-application';
import { trackJivoxPixel } from '../../utils/analytics.mjs';
import { JIVOX_CONVERTIONS_URL } from '../../../../../../../online-wealth/src/main/js/utils/constants.mjs';

const SurveyPage = ({ className, componentClass, renderQuestionGroups }) => {

  const { currentPageType, currentPageUrl } = usePages();
  const { guideId } = useGuideConfig();

  const isWealthGuide = guideId === 60;
  const currentPageName = currentPageUrl.split('/').pop();
  const jivoxPageData = `${currentPageType}|${currentPageName}` || null; 
  const jivoxUrl = encodeURI(`${JIVOX_CONVERTIONS_URL.onEveryPageLoad}&cOpt=${jivoxPageData}`);

  useEffect(() => {
    if(isWealthGuide) {
      trackJivoxPixel(encodeURI(jivoxUrl)); // Convertion tag
    }
  }, []);
  

  return (
    <div className={ className } aria-live="polite">
      <div className={`questionGroups ${componentClass}__questionGroups`}>
        { renderQuestionGroups() }
      </div>
    </div>
  );
};

export default SurveyPage;
